function initBundleSwiper() {
  const swiperEl = document.querySelector('.model-swiper');
  if (swiperEl) {
    new Swiper('.model-swiper', {
      slidesPerView: 2.2,
      spaceBetween: 12,
      watchOverflow: true,
      grabCursor: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        750: {
          slidesPerView: 3
        }
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', initBundleSwiper);
document.addEventListener('shopify:section:load', initBundleSwiper);